/*=================================================
    summary: 老師 看 / 改 學生考卷 組合題 Composition 單元
             練習 說一說        LUSeqNo: 14             
             練習 寫一寫        LUSeqNo: 18
             練習 小組活動      LUSeqNo: 19
             複習 寫一寫        LUSeqNo: 22
             複習 說一說        LUSeqNo: 23

             Practice Speaking
             Practice Writing Composition
             Practice Activity
             Review Writing Composition
             Review Speaking

    remarks: 000 Tim 2021/12/09 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
             002 Tim 2022/01/21 加入 滾動條 Top More提示
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentComposition from './AssignmentComposition.module.scss'
import './AssignmentComposition.css'
import '../../../../Utils/OldContentInlinClass.css'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ImageTypeEnum } from '../../../ImageDisplayWindow/ImageDisplayWindow.js'
import parse from 'html-react-parser'
import {ClientGatewayInPackage, GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Const
const IMAGE_DISPLAY_WIDTH = 506
const MAX_FEEDBACK_CHARACHERS = 1000 // Textarea最大的數字限制
// #endregion Const

// #region Enumeration
const SwitchTypeEnum = {
    "StudentAnswer": 0,
    "Comments": 1
}

const ScrollDisplayEnum = {
    "Hidden": 0,
    "Top": 1,
    "More": 2
}
// #endregion Enumeration

// #region State Member Variables
let mstrStateFeedbackText = ""
let mintStateAnswerAudioCurrentTime = 0
let mintStateAnswerAudioStatus = 0
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mobjDisplayQuestion = []
let mstrImagePrefix = ""
let mintAnswerAudioDuration = 0

let mobjContentData = []
let mintImgIndex4PreloadThumbnailImage = 0 
let mintImgIndex4PreloadOriginalImage = 0
// #endregion Member Variables


const COMP_NAME = "AssignmentComposition"

function AssignmentComposition(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [switchType, setSwitchType] = useState(SwitchTypeEnum.StudentAnswer)
    const [answerAudioStatus, setAnswerAudioStatus] = useState(window.gAudioStatusEnum.Stop)
    const [answerAudioCurrentTime, setAnswerAudioCurrentTime] = useState(0)
    const [isShowTextMore, setIsShowTextMore] = useState(false)
    const [subTextHeight, setSubTextHeight] = useState(-1)
    const [feedbackText, setFeedbackText] = useState("")

    const [scrollDisplayType, setScrollDisplayType] = useState(ScrollDisplayEnum.Hidden)
    // #endregion Init State

    // #region Init Ref
    let mrefAnswerText = useRef(null)
    let mrefSubAnswerText = useRef(null)
    let mrefCommentText = useRef(null)
    let mrefSubCommentText = useRef(null)

    let mrefScrollArea = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mintStateAnswerAudioStatus = window.gAudioStatusEnum.Stop
        mstrImagePrefix = window.Globals.GetResourcePrefix(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Image)

        RegisterGetTeacherFeedback()

        if (
            (
                (!window.gSession.App.InApp) ||
                (
                    (window.gSession.App.InApp) &&
                    (window.gSession.App.iOSNewGateway)
                )
            ) &&
            (props.AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
            )
        {
            RegisterAudioRecordingWindowCloseWithResult()
        } // end of if (props.AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update answerAudioCurrentTime
    useEffect(() => {
        mintStateAnswerAudioCurrentTime = answerAudioCurrentTime
        // console.log(COMP_NAME + ".Update answerAudioCurrentTime: mintStateAnswerAudioCurrentTime: ", mintStateAnswerAudioCurrentTime)    
    }, [answerAudioCurrentTime])

    // Update answerAudioStatus
    useEffect(() => {
        mintStateAnswerAudioStatus = answerAudioStatus
    }, [answerAudioStatus])

    // Update feedbackText
    useEffect(() => {
        mstrStateFeedbackText = feedbackText

        console.log(COMP_NAME + ".Update feedbackText: mstrStateFeedbackText: ", mstrStateFeedbackText)    
    }, [feedbackText])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()
        
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false

            mrefCleanUp.current()

            setFeedbackText("")
            setUpdateDataTime(0)
            setSwitchType(SwitchTypeEnum.StudentAnswer)
            setIsShowTextMore(false)
            setSubTextHeight(-1)
        }
    }, [props.PageIndex])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioCanplayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(AudioTimeUpdatedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
        window.AudioLibs.RegisterEventHandlerRef(AudioDurationChangedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)

        window.addEventListener("resize", WindowOnResizeEventHandler)

        InitContentDataProcessBegin()
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理離開流程
    remarks: 000 Tim 2022/01/21 Create
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)

        window.removeEventListener('resize', WindowOnResizeEventHandler)
    } // end of CleanUp
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 學生做答 按鈕
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function StudentAnswerOnTapHandler()
    {
        console.log(COMP_NAME + ".StudentAnswerOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)

        mintAnswerAudioDuration = 0
        setAnswerAudioCurrentTime(0)
        setUpdateDataTime(new Date().getTime())
        
        setSwitchType(SwitchTypeEnum.StudentAnswer)
        setIsShowTextMore(false)
        setSubTextHeight(-1)

        setTimeout(function()
        {
            // 需要 延遲一下 再預讀音檔，不然 音檔播放狀態 會亂掉
            // 學生錄音 不是 空的 就先預讀 取得 音檔長度
            if (mobjDisplayQuestion.RecordedAnswerUrl !== "")
            {
                window.AudioLibs.PreloadAudio(mobjDisplayQuestion.RecordedAnswerUrl)
            }
            
            // 需要 延遲一下 再做Resize處理
            WindowOnResizeEventHandler()
        }, 100)
    } // end of StudentAnswerOnTapHandler

    /*===========================================
    summary: 點選 評語 按鈕
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function CommentsOnTapHandler()
    {
        console.log(COMP_NAME + ".CommentsOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)

        mintAnswerAudioDuration = 0
        setAnswerAudioCurrentTime(0)
        setUpdateDataTime(new Date().getTime())

        setSwitchType(SwitchTypeEnum.Comments)
        setIsShowTextMore(false)
        setSubTextHeight(-1)

        setTimeout(function()
        {
            // 需要 延遲一下 再預讀音檔，不然 音檔播放狀態 會亂掉
            // 學生錄音 不是 空的 就先預讀 取得 音檔長度
            if (mobjDisplayQuestion.TeacherFeedbackAudioUrl !== "")
            {
                window.AudioLibs.PreloadAudio(mobjDisplayQuestion.TeacherFeedbackAudioUrl)
            } // end of if (mobjDisplayQuestion.TeacherFeedbackAudioUrl !== "")

            // 需要 延遲一下 再做Resize處理
            WindowOnResizeEventHandler()
        }, 100)
    } // end of CommentsOnTapHandler

    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioPlayOnTapHandler(RecordedAnswerUrl, StateAnswerAudioStatus)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler: RecordedAnswerUrl: ", RecordedAnswerUrl)
        console.log(COMP_NAME + ".AudioPlayOnTapHandler: StateAnswerAudioStatus: ", StateAnswerAudioStatus)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateAnswerAudioStatus === window.gAudioStatusEnum.Paused)
        {
            window.AudioLibs.Play()
        }
        else
        {
            window.AudioLibs.PlayAudio(RecordedAnswerUrl)
        }

        setAnswerAudioStatus(window.gAudioStatusEnum.Playing)
    } // end of AudioPlayOnTapHandler

    /*===========================================
    summary: 點選 聲音停止
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioStopOnTapHandler()
    {
        console.log(COMP_NAME + ".AudioStopOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        setAnswerAudioCurrentTime(0)
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)
    } // end of AudioStopOnTapHandler

    /*===========================================
    summary: 點選 聲音暫停
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioPauseOnTapHandler()
    {
        console.log(COMP_NAME + ".AudioPauseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.PauseAudio()

        setAnswerAudioStatus(window.gAudioStatusEnum.Paused)
    } // end of AudioPauseOnTapHandler

    /*===========================================
    summary: 點選 老師評語聲音 刪除
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function AudioDeleteOnTapHandler()
    {
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        mobjDisplayQuestion.TeacherFeedbackAudioUrl = ""

        setAnswerAudioCurrentTime(0)
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)
        setUpdateDataTime(new Date().getTime())
    } // end of AudioDeleteOnTapHandler

    /*===========================================
    summary: 點選 老師評語聲音 刪除
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function UserImageOnTapHandler(ImageAnswerUrl)
    {
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        setAnswerAudioCurrentTime(0)
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)

        let objCallbackData = {
            "Action": "OpenShowImageDisplayWindow",
            "Arguments": {
                "ImageType": ImageTypeEnum.Composition,
                "ImageUrl": ImageAnswerUrl
            }
        }

        props.CallbackRef(objCallbackData)
    } // end of UserImageOnTapHandler

    /*===========================================
    summary: 點選 老師評語聲音 刪除
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function VideoDeleteOnTapHandler()
    {
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        mobjDisplayQuestion.TeacherFeedbackVideoUrl = ""

        setAnswerAudioCurrentTime(0)
        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)
        setUpdateDataTime(new Date().getTime())
    } // end of VideoDeleteOnTapHandler

    /*===========================================
    summary: 點選 顯示更堆文字
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function MoreEventHandler()
    {
        console.log(COMP_NAME + ".MoreEventHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(mrefSubAnswerText.current) !== 'undefined') &&
            (mrefSubAnswerText.current !== null) &&
            (typeof(mrefSubAnswerText.current.clientHeight) !== 'undefined') &&
            (mrefSubAnswerText.current.clientHeight !== null) &&
            (mrefSubAnswerText.current.clientHeight > 0)
            )
        {
            setSubTextHeight(mrefSubAnswerText.current.clientHeight)
        }
        else if (
            (typeof(mrefSubCommentText.current) !== 'undefined') &&
            (mrefSubCommentText.current !== null) &&
            (typeof(mrefSubCommentText.current.clientHeight) !== 'undefined') &&
            (mrefSubCommentText.current.clientHeight !== null) &&
            (mrefSubCommentText.current.clientHeight > 0)
            )
        {
            setSubTextHeight(mrefSubCommentText.current.clientHeight)
        }
    } // end of MoreEventHandler

    /*===========================================
    summary: 點選 貼上學生答案 按鈕
    remarks: 000 Tim 2021/12/14 Create
             001 Tim 2022/01/21 超過 最大字數 直接截斷   Tim22.01.21
    ===========================================*/
    function PasteEventHandler(StateFeedbackText, CompositionAns)
    {
        console.log(COMP_NAME + ".PasteEventHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strComment = StateFeedbackText + CompositionAns
        // 超過 最大字數 直接截斷   Tim22.01.21
        if (strComment.length > MAX_FEEDBACK_CHARACHERS)
        {
            strComment = strComment.substr(0, MAX_FEEDBACK_CHARACHERS)
        }

        setFeedbackText(strComment)
    } // end of PasteEventHandler

    /*===========================================
    summary: 點選 影片播放
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function VideoPlayOnTapHandler(TeacherFeedbackVideoUrl)
    {
        console.log(COMP_NAME + ".VideoPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)

        let strPosterFN = "teachers_feedback";
        let strPosterUrl = GetVideoPoster(strPosterFN, props.BookCatID)

        let objCallbackData = {
            "Action": "OpenShowViderPlayerWindow",
            "Arguments": {
                "Title": "",
                "VideoUrl": TeacherFeedbackVideoUrl,
                "PosterUrl": strPosterUrl
            }
        }

        props.CallbackRef(objCallbackData)
    } // end of VideoPlayOnTapHandler

    /*===========================================
    summary: 取得 Video Poster
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function GetVideoPoster(PosterFN, BookCatID)
    {
        console.log(COMP_NAME + ".GetVideoPoster: PosterFN: ", PosterFN)

        // https://appfsdev.betterchinese.com/original/ BookCategory03/image/animation_poster_major_01.png

        let strPosterUrl = ""
        let strPosterFN = PosterFN

        if (
            (!window.gSession.App.InApp) ||
            (window.devicePixelRatio < 2)
            )
        {
            strPosterFN += "_min"
        }
        strPosterFN += ".png"

        strPosterUrl = PackageVariablesLibs.SysConfig.FileServerURL + "BookCategory" + BookCatID + "/image/" + strPosterFN

        return strPosterUrl
    } // end of GetVideoPoster

    /*===========================================
    summary: 點選 錄音
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function AudioRecordOnTapHandler()
    {
        console.log(COMP_NAME + ".AudioRecordOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let blnCanSupport = true
        if (
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.Edge) ||
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)
            )
        {
            blnCanSupport = false
        } // end of if (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)

        if (blnCanSupport)
        {
            if (!window.gSession.App.InApp)
            {
                // Web
                OpenShowAudioRecordingWindow()
            } // end of if (!window.gSession.App.InApp)
            else
            {
                // App
                if (window.gSession.App.iOSNewGateway)
                {
                    // SwiftUI
                    console.log("SwiftUI")
                    
                    OpenShowAudioRecordingWindow()
                } // end of if (window.gSession.App.iOSNewGateway)
                else
                {
                    console.log("Not SwiftUI")
                    CallAppOpenAudioRecorder()
                } // end of else
            } // end of else 
        } // end of if (blnCanSupport)
        else
        {
            let objAlertObject = {
                Header: window.gAppUI.MSG_Alert_Title_Google_SR_NotSupport,
                Body: window.gAppUI.MSG_Alert_Msg_Audio_Record_NotSupport,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        } // end of else
    } // end of AudioRecordOnTapHandler

    /*===========================================
    summary: 點選 錄影
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function VideoRecordOnTapHandler()
    {
        console.log(COMP_NAME + ".VideoRecordOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        VideoRecordFromApp()
    } // end of VideoRecordOnTapHandler

    /*===========================================
    summary: 點選 滾動顯示按鈕
    remarks: 000 Tim 2022/01/21 Create
    ===========================================*/
    function ScrollDisplayOnTapHandler()
    {
        // console.log(COMP_NAME + ".ScrollDisplayOnTapHandler: ")

        if (
            (typeof (mrefScrollArea) !== 'undefined') &&
            (mrefScrollArea !== null) &&
            (typeof (mrefScrollArea.current) !== 'undefined') &&
            (mrefScrollArea.current !== null)
            )
        {

            let intScrollHeight = mrefScrollArea.current.scrollHeight; // scrollHeight
            let intScrollTop = mrefScrollArea.current.scrollTop; // scrollTop

            // console.log("intScrollHeight:", intScrollHeight)
            // console.log("intScrollTop:", intScrollTop)

            let intClientHeight = mrefScrollArea.current.clientHeight; // .divScrollArea 的高度

            // console.log("intClientHeight:", intClientHeight)

            if ((intScrollTop + intClientHeight) === intScrollHeight)
            {
                console.log("ScrollDisplayOnTapHandler: Scroll已在最底")
                // 如果現在是在Scroll的最底端 則回到最Top
                GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 300)
            }
            else
            {
                console.log("ScrollDisplayOnTapHandler: Scroll未在最底")
                // 如果未到底 就向下移動 (clientHeight / 2) 如果已到最底 則不動
                // Scroll To Somewhere
                let intScrollTo = intScrollTop
                if ((intScrollTop + intClientHeight) !== intScrollHeight)
                {
                    intScrollTo = intClientHeight / 2
                }

                GlobalLibs.ExecuteScrollBy(mrefScrollArea.current, intScrollTo, 0, 300)
            }
        }
    } // end of ScrollDisplayOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Feedback 改變 事件
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function FeedbackChangeHandler(e)
    {
        // console.log(COMP_NAME + ".FeedbackChangeHandler: e.target.value:", e.target.value)
        setFeedbackText(e.target.value)
    } // end of FeedbackChangeHandler

    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        setAnswerAudioStatus(window.gAudioStatusEnum.Stop)
        setAnswerAudioCurrentTime(mintAnswerAudioDuration)
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 音檔 讀取完畢 可以播放 
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioCanplayHandler()
    {
        console.log(COMP_NAME + ".AudioCanplayHandler")

        // CloseLoadingMask()
    } // end of AudioCanplayHandler

    /*===========================================
    summary: 播放聲音 時間更新
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioTimeUpdatedHandler(CurrentTime)
    {
        console.log(COMP_NAME + ".AudioTimeUpdatedHandler")

        if (
            (mintStateAnswerAudioStatus !== window.gAudioStatusEnum.Paused) &&
            (Math.ceil(mintStateAnswerAudioCurrentTime) !== Math.ceil(CurrentTime))
            )
        {
            // console.log(COMP_NAME + ".AudioTimeUpdatedHandler mintStateAnswerAudioCurrentTime: ", mintStateAnswerAudioCurrentTime)
            // console.log(COMP_NAME + ".AudioTimeUpdatedHandler CurrentTime: ", CurrentTime)
            setAnswerAudioCurrentTime(CurrentTime)
        } // end of if (Math.ceil(mintStateAnswerAudioCurrentTime) !== Math.ceil(CurrentTime))
    } // end of AudioTimeUpdatedHandler

    /*===========================================
    summary: 播放聲音 音檔總時間變化
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function AudioDurationChangedHandler(Duration)
    {
        console.log(COMP_NAME + ".AudioDurationChangedHandler: ", Duration)

        if (mintAnswerAudioDuration !== Duration)
        {
            mintAnswerAudioDuration = Duration
            setUpdateDataTime(new Date().getTime())
        } // end of if (mintAnswerAudioDuration !== Duration)
    } // end of AudioDurationChangedHandler

    /*===========================================
    summary: 改變視窗大小 處理事件
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function WindowOnResizeEventHandler()
    {
        // console.log(COMP_NAME + ".WindowOnResizeEventHandler")
        
        if (
            (typeof(mrefAnswerText.current) !== 'undefined') &&
            (mrefAnswerText.current !== null) &&
            (typeof(mrefAnswerText.current.clientHeight) !== 'undefined') &&
            (mrefAnswerText.current.clientHeight !== null) &&
            (mrefAnswerText.current.clientHeight > 0) &&
            (typeof(mrefSubAnswerText.current) !== 'undefined') &&
            (mrefSubAnswerText.current !== null) &&
            (typeof(mrefSubAnswerText.current.clientHeight) !== 'undefined') &&
            (mrefSubAnswerText.current.clientHeight !== null) &&
            (mrefSubAnswerText.current.clientHeight > 0)
            )
        {
            if (mrefAnswerText.current.clientHeight < mrefSubAnswerText.current.clientHeight)
            {
                setIsShowTextMore(true)
            }
        }
        else if (
            (typeof(mrefCommentText.current) !== 'undefined') &&
            (mrefCommentText.current !== null) &&
            (typeof(mrefCommentText.current.clientHeight) !== 'undefined') &&
            (mrefCommentText.current.clientHeight !== null) &&
            (mrefCommentText.current.clientHeight > 0) &&
            (typeof(mrefSubCommentText.current) !== 'undefined') &&
            (mrefSubCommentText.current !== null) &&
            (typeof(mrefSubCommentText.current.clientHeight) !== 'undefined') &&
            (mrefSubCommentText.current.clientHeight !== null) &&
            (mrefSubCommentText.current.clientHeight > 0)
            )
        {
            if (mrefCommentText.current.clientHeight < mrefSubCommentText.current.clientHeight)
            {
                setIsShowTextMore(true)
            }
        }

        SetScrollDisplayType4ScrollArea()
    } // end of WindowOnResizeEventHandler

    /*===========================================
    summary: 滾動 處理事件
    remarks: 000 Tim 2022/01/21 Create
    ===========================================*/
    function ScrollAreaScrollEventHandler(e)
    {
        // console.log(COMP_NAME + ".ScrollAreaScrollEventHandler: ", e)

        let intScrollHeight = e.target.scrollHeight   // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
        // let intScrollWidth = e.target.scrollWidth     // scrollWidth
        // let intScrollLeft = e.target.scrollLeft       // scrollLeft
        let intScrollTop = e.target.scrollTop         // scrollTop

        // console.log("intScrollHeight:", intScrollHeight)
        // console.log("intScrollWidth:", intScrollWidth)
        // console.log("intScrollLeft:", intScrollLeft)
        // console.log("intScrollTop:", intScrollTop)

        let intClientHeight = e.target.clientHeight // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
        // let intClientWidth = e.target.clientWidth // clientWidth Ref: 
        // let intClientTop = e.target.clientTop // clientTop
        // let intClientLeft = e.target.clientLeft // clientLeft

        // console.log("intClientHeight:", intClientHeight)
        // console.log("intClientWidth:", intClientWidth)
        // console.log("intClientTop:", intClientTop)
        // console.log("intClientLeft:", intClientLeft)

        // if (intScrollTop === 0)
        // {
        //     console.log('Reached scroll div top')
        // }

        if (
            (typeof (mrefScrollArea) !== 'undefined') &&
            (mrefScrollArea !== null) &&
            (typeof (mrefScrollArea.current) !== 'undefined') &&
            (mrefScrollArea.current !== null)
            )
        {
            // 無Scroll時 讓按鈕消失
            if (mrefScrollArea.current.scrollHeight <= mrefScrollArea.current.clientHeight)
            {
                // 無Scroll
                setScrollDisplayType(ScrollDisplayEnum.Hidden)
            }
            else
            {
                if ((intScrollTop + intClientHeight) === intScrollHeight)
                {
                    // 目前到最底 則切換 Top/Down圖示
                    console.log('Reached scroll div bottom')
                    setScrollDisplayType(ScrollDisplayEnum.Top)
                }
                else
                {
                    setScrollDisplayType(ScrollDisplayEnum.More)
                }
            }
        }
    } // end of ScrollAreaScrollEventHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2022/12/13 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert

    /*===========================================
    summary: 開啟 錄音視窗
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function OpenShowAudioRecordingWindow()
    {
        let objCallbackData = {
            "Action": "OpenShowAudioRecordingWindow"
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenShowAudioRecordingWindow
    // #endregion LoadingMask and Alert

    // #region Other Functions
    /*===========================================
    summary: 註冊 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RegisterGetTeacherFeedback ()
    {
        let objCallbackData = {
            "Action": "RegisterGetTeacherFeedback",
            "Function": GetTeacherFeedback
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterGetTeacherFeedback

    /*===========================================
    summary: 註冊 錄音視窗 回傳結果
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function RegisterAudioRecordingWindowCloseWithResult ()
    {
        let objCallbackData = {
            "Action": "RegisterAudioRecordingWindowCloseWithResult",
            "Function": AudioRecordingWindowCloseWithResult
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterAudioRecordingWindowCloseWithResult

    /*===========================================
    summary: 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function GetTeacherFeedback ()
    {
        console.log(COMP_NAME + ".GetTeacherFeedback: mobjDisplayQuestion:", mobjDisplayQuestion)

        let objTeacherFeedback = {
            "AnswerID": mobjDisplayQuestion.AnswerID,
            "PageIndex": props.PageIndex,
            "TeacherFeedbackText": "",
            "TeacherFeedbackAudioFN": "",
            "TeacherFeedbackVideoFN": ""
        }

        if (
            (typeof(mstrStateFeedbackText) !== 'undefined') &&
            (mstrStateFeedbackText !== null) &&
            (mstrStateFeedbackText !== "") 
            )
        {
            objTeacherFeedback.TeacherFeedbackText = mstrStateFeedbackText
        }

        // TeacherFeedbackAudioFN
        if (mobjDisplayQuestion.TeacherFeedbackAudioUrl !== "")
        {
            objTeacherFeedback.TeacherFeedbackAudioFN = mobjDisplayQuestion.TeacherFeedbackAudioUrl
        } // end of if (mobjDisplayQuestion.TeacherFeedbackAudioUrl !== "")

        // TeacherFeedbackVideoFN
        if (mobjDisplayQuestion.TeacherFeedbackVideoUrl !== "")
        {
            objTeacherFeedback.TeacherFeedbackVideoFN = mobjDisplayQuestion.TeacherFeedbackVideoUrl
        } // end of if (mobjDisplayQuestion.TeacherFeedbackVideoUrl !== "")

        return objTeacherFeedback
    } // end of GetTeacherFeedback

    /*===========================================
    summary: 註冊 錄音視窗 回傳結果
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function AudioRecordingWindowCloseWithResult (AudioBase64)
    {
        console.log(COMP_NAME + ".AudioRecordingWindowCloseWithResult: AudioBase64: ", AudioBase64)

        if (
            (typeof(AudioBase64) !== 'undefined') &&
            (AudioBase64 !== null) &&
            (AudioBase64.length > 0)
            )
        {
            mobjDisplayQuestion.TeacherFeedbackAudioUrl = AudioBase64

            window.AudioLibs.PreloadAudio(mobjDisplayQuestion.TeacherFeedbackAudioUrl)
        } // end of if (AudioBase64.length > 0)

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioCanplayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(AudioTimeUpdatedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
        window.AudioLibs.RegisterEventHandlerRef(AudioDurationChangedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)
        
        setUpdateDataTime(new Date().getTime())
    } // end of AudioRecordingWindowCloseWithResult
    
    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        mobjContentData = []

        let arrImage = []
        let arrKeywordList = []
        let objContent = null

        // 這個單元 一次 只讀一頁的資訊
        let objSuperQuestion = props.LearningUnitData.SuperQuestion[props.PageIndex]
        
        // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        // Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示

        arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? objSuperQuestion.ContentHTML.MajorLangKeyword : objSuperQuestion.ContentHTML.MinorLangKeyword
        objContent = window.Globals.CreateContentText(objSuperQuestion.ContentHTML.TextWithHeight, arrKeywordList, mstrImagePrefix)

        console.log("objContent: ", objContent)
        console.log("arrImage: ", arrImage)

        mobjContentData = objContent

        console.log("mobjContentData: ", mobjContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        mobjDisplayQuestion = FormatCompositionDisplayQuestion(props.LearningUnitData, props.TeacherAssignmentData, props.PageIndex)

        // 顯示縮圖後 再去Load大圖
        setUpdateDataTime(new Date().getTime())

        setTimeout(function()
        {
            WindowOnResizeEventHandler()
        }, 100)

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd

    // #region PreloadImage
    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintImgIndex4PreloadThumbnailImage = 0

        if (mobjContentData.ImageList.length > 0)
        {
            LoadThumbnailImage(mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            GotoNextLoadThumbnailImage(mintImgIndex4PreloadThumbnailImage)
        }
    } // end of PreloadThumbnailImageProcessBegin

    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
        mobjContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(mobjContentData.ContentText, mobjContentData.ImageList)

        console.log("PreloadThumbnailImageProcessEnd END mobjContentData: ", mobjContentData)

        InitContentDataProcessEnd()
    } // end of PreloadImageProcessEnd

    /*===========================================
    summary: 讀取 縮圖 題目圖片
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function LoadThumbnailImage(ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", ImgIndex)
        console.log(COMP_NAME + ".LoadThumbnailImage Image: ", mobjContentData.ImageList[ImgIndex])

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(ImgIndex, this.width, this.height)
        }; // end of image onload
        // objImage.src = mobjContentData.ImageList[ImgIndex].Url
        objImage.src = mobjContentData.ImageList[ImgIndex].ThumbnailImageUrl
    } // end of LoadThumbnailImage

    /*===========================================
    summary: 讀取 縮圖 題目圖片完成 事件
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function ThumbnailImageLoadedHandler(ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if (
            (mobjContentData !== null) &&

            (typeof(mobjContentData.ImageList) !== "undefined") &&
            (mobjContentData.ImageList !== null) &&

            (typeof(mobjContentData.ImageList[ImgIndex]) !== "undefined") &&
            (mobjContentData.ImageList[ImgIndex] !== null)
            )
        {
            mobjContentData.ImageList[ImgIndex].Width = Width
            mobjContentData.ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            mobjContentData.ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            mobjContentData.ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler END DisplayHeight: ", parseInt(mobjContentData.ImageList[ImgIndex].DisplayHeight))

            GotoNextLoadThumbnailImage(ImgIndex)
        } // end of if (mobjContentData.ImageList[ImgIndex] !== null)
        else
        {
            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler ContentData null ")
        }
    } // end of ThumbnailImageLoadedHandler

    /*===========================================
    summary: 繼續讀取下一張 縮圖
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function GotoNextLoadThumbnailImage(ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadThumbnailImage: ", ImgIndex)

        if (
            (mobjContentData.ImageList.length > 0) &&
            (ImgIndex < (mobjContentData.ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadThumbnailImage++
            LoadThumbnailImage(mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    } // end of GotoNextLoadThumbnailImage

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")

        mintImgIndex4PreloadOriginalImage = 0

        if (mobjContentData.ImageList.length > 0)
        {
            LoadOriginalImage(mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            GotoNextLoadOriginalImage(mintImgIndex4PreloadOriginalImage)
        }
    } // end of PreloadOriginalImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")
    } // end of PreloadImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 題目圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalImage(ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(ImgIndex)
        }; // end of image onload
        // objImage.src = mobjContentData.ImageList[ImgIndex].Url
        objImage.src = mobjContentData.ImageList[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalImage

    /*===========================================
    summary: 讀取 原圖 題目圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalImageLoadedHandler(ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", ImgIndex)

        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if (
            (mobjContentData !== null) &&

            (typeof(mobjContentData.ImageList) !== "undefined") &&
            (mobjContentData.ImageList !== null) &&

            (typeof(mobjContentData.ImageList[ImgIndex]) !== "undefined") &&
            (mobjContentData.ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = mobjContentData.ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = mobjContentData.ContentText
            console.log("strContentText: ", strContentText)

            mobjContentData.ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)
            mobjDisplayQuestion.ContentText = mobjContentData.ContentText

            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalImage(ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalImageLoadedHandler ContentData null")
        }
    } // end of OriginalImageLoadedHandler

    /*===========================================
    summary: 繼續讀取 下一章 原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalImage(ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalImage: ", ImgIndex)

        if (
            (mobjContentData.ImageList.length > 0) &&
            (ImgIndex < (mobjContentData.ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadOriginalImage++
            LoadOriginalImage(mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalImage
    // #endregion PreloadImage
    
    /*===========================================
    summary: 初始化 組合題 答案資料
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function FormatCompositionDisplayQuestion(LearningUnit, TeacherAssignment, PageIndex)
    {
        console.log(COMP_NAME + ".FormatCompositionDisplayQuestion: ", LearningUnit, TeacherAssignment)

        let arrSuperQuestion = LearningUnit.SuperQuestion
        let objDisplayQuestion = null

        let intSQIndex = 0
        let intSQCount = arrSuperQuestion.length
        let arrAnswer = []
        let intAIndex = 0
        let intACount = 0
        let blnFound = false
        let intNAIndex = 0
        let intAssignID = -1

        let intSQSeqNo = 0
        
        let strTeacherFeedbackText = ""

        let objContent = null

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
            intAssignID = TeacherAssignment.NewAssignList[intNAIndex].AssignID
        }

        // for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        if (PageIndex < intSQCount)
        {
            intSQIndex = PageIndex
            intSQSeqNo = parseInt(arrSuperQuestion[intSQIndex].SQSeqNo)

            // 處理 顯示的 Content
            objContent = mobjContentData
            console.log(COMP_NAME + ".FormatCompositionDisplayQuestion: objContent: ", objContent)
            
            objDisplayQuestion = {
                "SQSeqNo": arrSuperQuestion[intSQIndex].SQSeqNo,
                "PageIndex": PageIndex,
                "ContentText": objContent.ContentText,
                "AudioFN": objContent.AudioFN,
                "IsAudio": objContent.IsAudio,
                "RecordedAnswerUrl": "",
                "ImageAnswer01Url": "",
                "ImageAnswer02Url": "",
                "ImageAnswer03Url": "",
                "CompositionAns": "",
                "TeacherFeedbackText": "",
                "TeacherFeedbackAudioUrl": "",
                "TeacherFeedbackVideoUrl": ""
            }

            // 找出 使用者 選擇的答案
            intAIndex = 0
            intACount = arrAnswer.length
            blnFound = false
            while ((!blnFound) && (intAIndex < intACount))
            {   
                if (parseInt(arrAnswer[intAIndex].SQSeqNo) === intSQSeqNo)
                {
                    blnFound = true
                    objDisplayQuestion.AnswerID = arrAnswer[intAIndex].AnswerID

                    console.log(COMP_NAME + ".FormatCompositionDisplayQuestion: 2 arrAnswer[intAIndex]: ", arrAnswer[intAIndex], intAIndex)

                    // SQCompAudio
                    if (
                        (typeof(arrAnswer[intAIndex].RecordedAnsFN) !== 'undefined') &&
                        (arrAnswer[intAIndex].RecordedAnsFN !== null) &&
                        (arrAnswer[intAIndex].RecordedAnsFN !== "")
                        )
                    {
                        objDisplayQuestion.RecordedAnswerUrl = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].RecordedAnsFN)
                    }

                    // SQCompImg1
                    if (
                        (typeof(arrAnswer[intAIndex].ImageAns01FN) !== 'undefined') &&
                        (arrAnswer[intAIndex].ImageAns01FN !== null) &&
                        (arrAnswer[intAIndex].ImageAns01FN !== "")
                        )
                    {
                        objDisplayQuestion.ImageAnswer01Url = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].ImageAns01FN)
                    }

                    // SQCompImg2
                    if (
                        (typeof(arrAnswer[intAIndex].ImageAns02FN) !== 'undefined') &&
                        (arrAnswer[intAIndex].ImageAns02FN !== null) &&
                        (arrAnswer[intAIndex].ImageAns02FN !== "")
                        )
                    {
                        objDisplayQuestion.ImageAnswer02Url = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].ImageAns02FN)
                    }

                    // SQCompImg3
                    if (
                        (typeof(arrAnswer[intAIndex].ImageAns03FN) !== 'undefined') &&
                        (arrAnswer[intAIndex].ImageAns03FN !== null) &&
                        (arrAnswer[intAIndex].ImageAns03FN !== "")
                        )
                    {
                        objDisplayQuestion.ImageAnswer03Url = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].ImageAns03FN)
                    }

                    // SQCompText
                    if (
                        (typeof(arrAnswer[intAIndex].CompositionAns) !== 'undefined') &&
                        (arrAnswer[intAIndex].CompositionAns !== null) &&
                        (arrAnswer[intAIndex].CompositionAns !== "")
                        )
                    {
                        objDisplayQuestion.CompositionAns = arrAnswer[intAIndex].CompositionAns 
                        // objDisplayQuestion.CompositionAns += "0003456789 0013456789 0023456789 0033456789 0043456789 0053456789 0063456789 0073456789 0083456789 0093456789"
                        // objDisplayQuestion.CompositionAns += "0103456789 0113456789 0123456789 0133456789 0143456789 0153456789 0163456789 0173456789 0183456789 0193456789"
                        // objDisplayQuestion.CompositionAns += "0203456789 0213456789 0223456789 0233456789 0243456789 0253456789 0263456789 0273456789 0283456789 0293456789"
                        // objDisplayQuestion.CompositionAns += "0303456789 0313456789 0323456789 0333456789 0343456789 0353456789 0363456789 0373456789 0383456789 0393456789"
                        // objDisplayQuestion.CompositionAns += "0403456789 0413456789 0423456789 0433456789 0443456789 0453456789 0463456789 0473456789 0483456789 0493456789"
                        // objDisplayQuestion.CompositionAns += "0503456789 0513456789 0523456789 0533456789 0543456789 0553456789 0563456789 0573456789 0583456789 0593456789"
                        // objDisplayQuestion.CompositionAns += "0603456789 0613456789 0623456789 0633456789 0643456789 0653456789 0663456789 0673456789 0683456789 0693456789"
                        // objDisplayQuestion.CompositionAns += "0703456789 0713456789 0723456789 0733456789 0743456789 0753456789 0763456789 0773456789 0783456789 0793456789"
                        // objDisplayQuestion.CompositionAns += "0803456789 0813456789 0823456789 0833456789 0843456789 0853456789 0863456789 0873456789 0883456789 0893456789"
                        // objDisplayQuestion.CompositionAns += "0903456789 0913456789 0923456789 0933456789 0943456789 0953456789 0963456789 0973456789 0983456789 0993456789" 
                    }

                    // TeacherFeedbackText
                    if (
                        (typeof(arrAnswer[intAIndex].TeacherFeedbackText) !== 'undefined') &&
                        (arrAnswer[intAIndex].TeacherFeedbackText !== null) &&
                        (arrAnswer[intAIndex].TeacherFeedbackText !== "")
                        )
                    {
                        objDisplayQuestion.TeacherFeedbackText = arrAnswer[intAIndex].TeacherFeedbackText
                        // objDisplayQuestion.TeacherFeedbackText += "0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789 0123456789"
                        strTeacherFeedbackText = arrAnswer[intAIndex].TeacherFeedbackText
                    } // end of if (arrAnswer[intAIndex].TeacherFeedbackText !== null)

                    // TeacherFeedbackAudioFN
                    if (
                        (typeof(arrAnswer[intAIndex].TeacherFeedbackAudioFN) !== 'undefined') &&
                        (arrAnswer[intAIndex].TeacherFeedbackAudioFN !== null) &&
                        (arrAnswer[intAIndex].TeacherFeedbackAudioFN !== "")
                        )
                    {
                        // console.log(COMP_NAME + ".FormatCompositionDisplayQuestion: TeacherFeedbackAudioFN: ", arrAnswer[intAIndex].TeacherFeedbackAudioFN)
                        if (arrAnswer[intAIndex].TeacherFeedbackAudioFN.indexOf("base64") !== -1)
                        {
                            // Base64
                            objDisplayQuestion.TeacherFeedbackAudioUrl = arrAnswer[intAIndex].TeacherFeedbackAudioFN
                        }
                        else
                        {
                            // 後端檔案
                            objDisplayQuestion.TeacherFeedbackAudioUrl = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].TeacherFeedbackAudioFN)
                        }
                    } // end of if (arrAnswer[intAIndex].TeacherFeedbackAudioFN !== null)

                    // TeacherFeedbackVideoFN
                    if (
                        (typeof(arrAnswer[intAIndex].TeacherFeedbackVideoFN) !== 'undefined') &&
                        (arrAnswer[intAIndex].TeacherFeedbackVideoFN !== null) &&
                        (arrAnswer[intAIndex].TeacherFeedbackVideoFN !== "")
                        )
                    {
                        // console.log(COMP_NAME + ".FormatCompositionDisplayQuestion: TeacherFeedbackVideoFN: ", arrAnswer[intAIndex].TeacherFeedbackVideoFN)
                        if (arrAnswer[intAIndex].TeacherFeedbackVideoFN.indexOf("base64") !== -1)
                        {
                            // Base64
                            objDisplayQuestion.TeacherFeedbackVideoUrl = arrAnswer[intAIndex].TeacherFeedbackVideoFN   
                        }
                        else
                        {
                            // 後端檔案
                            objDisplayQuestion.TeacherFeedbackVideoUrl = window.Globals.GetUserNewAssignmentUrl(intAssignID, arrAnswer[intAIndex].TeacherFeedbackVideoFN)
                        }
                    } // end of if (arrAnswer[intAIndex].TeacherFeedbackVideoFN !== null)
                } // end of if (parseInt(arrAnswer[intAIndex].FQSeqNo) === intFQSeqNo)
                intAIndex++
            } // end of while
        } // end of if (PageIndex < intSQCount)

        setFeedbackText(strTeacherFeedbackText)

        console.log(COMP_NAME + ".FormatCompositionDisplayQuestion objDisplayQuestion: ", objDisplayQuestion)
        console.log(COMP_NAME + ".FormatCompositionDisplayQuestion strTeacherFeedbackText: ", strTeacherFeedbackText)
        console.log(COMP_NAME + ".FormatCompositionDisplayQuestion PageIndex: ", PageIndex)

        // 學生錄音 不是 空的 就先預讀 取得 音檔長度
        if (objDisplayQuestion.RecordedAnswerUrl !== "")
        {
            window.AudioLibs.PreloadAudio(objDisplayQuestion.RecordedAnswerUrl)
        }

        return objDisplayQuestion
    } // end of FormatCompositionDisplayQuestion

    /*===========================================
    summary: 取得顯示時間
    remarks: 000 Tim 2021/12/10
    ===========================================*/
    function GetDisplayTime(Time)
    {
        // console.log("GetDisplayTime: ", Time);

        let blnIsNan = isNaN(Time)
        if (blnIsNan)
        {
            Time = 0;
        }
        let intTimeInteger = Math.round(Time)
        let intTimeMinutes = Math.floor(intTimeInteger / 60);
        let intTimeSeconds = intTimeInteger % 60;

        let strSeconds = intTimeSeconds.toString().PadLeft(2)          // 左邊補零 Format "01"
        let strTime = intTimeMinutes.toString() + ":" + strSeconds

        return strTime
    } // end of GetDisplayTime

    /*===========================================
    summary: 設定滾動 滾動條按鈕
    remarks: 000 Tim 2022/01/21 Create
    ===========================================*/
    function SetScrollDisplayType4ScrollArea()
    {
        // console.log(COMP_NAME + ".SetScrollDisplayType4ScrollArea: ");

        if (
            (typeof (mrefScrollArea) !== 'undefined') &&
            (mrefScrollArea !== null) &&
            (typeof (mrefScrollArea.current) !== 'undefined') &&
            (mrefScrollArea.current !== null)
            )
        {
            // 無Scroll時 讓按鈕消失
            if (mrefScrollArea.current.scrollHeight <= mrefScrollArea.current.clientHeight)
            {
                // 無Scroll
                setScrollDisplayType(ScrollDisplayEnum.Hidden)
            }
            else
            {
                if ((mrefScrollArea.current.scrollTop + mrefScrollArea.current.clientHeight) === mrefScrollArea.current.scrollHeight)
                {
                    setScrollDisplayType(ScrollDisplayEnum.Top)
                }
                else
                {
                    setScrollDisplayType(ScrollDisplayEnum.More)
                }
            }
        }
    } // end of SetScrollDisplayType4ScrollArea
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 學生做答按鈕 Cls
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function GetSwitch4StudentAnswerButtonCls(StateSwitchType)
    {
        let objCls = cssAssignmentComposition.btnSwitch4StudentAnswer

        if (StateSwitchType === SwitchTypeEnum.StudentAnswer)
        {
            objCls = cssAssignmentComposition.btnSwitch4StudentAnswerSelected
        }

        return objCls
    } // end of GetSwitch4StudentAnswerButtonCls

    /*===========================================
    summary: 取得 評語按鈕 Cls
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function GetSwitch4CommentsButtonCls(StateSwitchType)
    {
        let objCls = cssAssignmentComposition.btnSwitch4Comments

        if (StateSwitchType === SwitchTypeEnum.Comments)
        {
            objCls = cssAssignmentComposition.btnSwitch4CommentsSelected
        }

        return objCls
    } // end of GetSwitch4CommentsButtonCls
    // #endregion Get ClassName

    // #region Get Style
    /*===========================================
    summary: 取得 文字答案 Style
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function GetTextAreaStyle(StateSubTextHeight)
    {
        let objStyle = null

        if (StateSubTextHeight > 0)
        {
            // 36px 為 上下留白空間
            objStyle = {
                "minHeight": (StateSubTextHeight + 36) + "px"
            }
        }

        return objStyle
    } // end of GetTextAreaStyle

    /*===========================================
    summary: 取得 使用者圖片 Style
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function GetUserImageStyle(ImageAnswerUrl)
    {
        let objStyle =  {
            "backgroundImage": "url(\"" + ImageAnswerUrl + "\")"
        }

        return objStyle
    } // end of GetUserImageStyle

    /*===========================================
    summary: 取得 Scroll Show Cls
    remarks: 000 Tim 2022/01/21 Create
    ===========================================*/
    function GetScrollDisplayCls(StateScrollDisplayType)
    {
        let objCls = cssAssignmentComposition.divHidden

        if (StateScrollDisplayType === ScrollDisplayEnum.Top)
        {
            objCls = cssAssignmentComposition.btnScrollDisplayTop
        }
        else if (StateScrollDisplayType === ScrollDisplayEnum.More)
        {
            objCls = cssAssignmentComposition.btnScrollDisplayMore
        }

        return objCls
    } // end of GetScrollDisplayCls
    // #endregion Get Style

    // #region Call App
    /*===========================================
    summary: 呼叫 App 執行 錄影
    remarks: 000 Tim 2021/12/15 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function VideoRecordFromApp ()
    {
        const FUNC_NAME = VideoRecordFromApp.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        // open loading mask?

        let strFN = ""
        let intAction = window.gConst.ACTION_VIDEO_RECORD
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&FileName=" + strFN

        console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackVideoRecordFromApp)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackVideoRecordFromApp)
    } // end of VideoRecordFromApp

    /*===========================================
    summary: 呼叫 App 執行 錄影 Callback
    remarks: 000 Tim 2021/12/15 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    ===========================================*/
    function BackFromAppCallbackVideoRecordFromApp (ReturnData) 
    {
        const FUNC_NAME = BackFromAppCallbackVideoRecordFromApp.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData)

        if (
            (typeof(ReturnData.Data) !== 'undefined') &&
            (ReturnData.Data !== null) &&
            (ReturnData.Data !== "")
            )
        {
            let strBase64Video = ReturnData.Data

            if (window.gSession.App.iOSNewGateway)
            {
                // 新架構 (SwiftUI版 已有加入data:video/mp4;base64, 在此就不用加)
                mobjDisplayQuestion.TeacherFeedbackVideoUrl = strBase64Video
            }
            else
            {
                // 舊架構
                mobjDisplayQuestion.TeacherFeedbackVideoUrl = "data:video/mp4;base64," + strBase64Video
            }
            console.log(COMP_NAME + "." + FUNC_NAME + " mobjDisplayQuestion: ", mobjDisplayQuestion)

            setUpdateDataTime(new Date().getTime())
        } // end of if (ReturnData.Data !== "")

        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromAppCallbackVideoRecordFromApp

    /*===========================================
    summary: 呼叫 App 執行 錄音
    remarks: 000 Tim 2022/01/21 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppOpenAudioRecorder()
    {
        const FUNC_NAME = CallAppOpenAudioRecorder.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        // and call App to open Audio Recorder
        let intAction = window.gConst.ACTION_AUDIO_RECORD
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential

        console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackOpenAudioRecorder)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackOpenAudioRecorder)
    } // end of CallAppOpenAudioRecorder

    /*===========================================
    summary: 呼叫 App 執行 錄音 Callback
    remarks: 000 Tim 2022/01/21 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    ===========================================*/
    function BackFromAppCallbackOpenAudioRecorder(ReturnData)
    {
        const FUNC_NAME = BackFromAppCallbackOpenAudioRecorder.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData)

        if (
            (typeof(ReturnData.Data) !== 'undefined') &&
            (ReturnData.Data !== null) &&
            (ReturnData.Data !== "")
            )
        {
            let strAudioBase64 = "data:audio/mp3;base64," + ReturnData.Data
            AudioRecordingWindowCloseWithResult(strAudioBase64)
        } // end of if (ReturnData.Data !== "")
        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromAppCallbackOpenAudioRecorder
    // #endregion Call App

    /*===========================================
    summary: 音檔工具列 暫停模式 顯示Component  
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentImageUnit( {ImageAnswerUrl} )
    {   
        if (ImageAnswerUrl !== "")
        {
            let objStyle = GetUserImageStyle(ImageAnswerUrl)

            return(
                <div className={cssAssignmentComposition.btnUserImage} style={objStyle} onClick={() => UserImageOnTapHandler(ImageAnswerUrl)}/>
            )
        }
        else
        {
            return(
                <div className={cssAssignmentComposition.divAnswerImageUnitArea}>
                    <div className={cssAssignmentComposition.divAddImageIcon}/>
                    <div className={cssAssignmentComposition.divImageMessage}>
                        {window.gAppUI.LBL_AddImage}
                    </div>
                </div>
            )
        }
    } // end of ComponentImageUnit

    /*===========================================
    summary: 音檔工具列 無音檔模式 顯示Component  (Comment才有)
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentAudioToolNoAudioMode()
    {   
        return(
            <>
                <div className={cssAssignmentComposition.btnAudioPlayDisabled}/>
                <div className={cssAssignmentComposition.btnAudioStopDisabled}/>
            </>
        )
    } // end of ComponentAudioToolNoAudioMode

    /*===========================================
    summary: 音檔工具列 刪除按鈕 顯示Component  
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function ComponentAudioDeleteButton( {PropsAssignReportStatus} )
    {   
        if (PropsAssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            return(
                <div className={cssAssignmentComposition.btnAudioDelete} onClick={() => AudioDeleteOnTapHandler()}/>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentAudioDeleteButton

    /*===========================================
    summary: 音檔工具列 暫停模式 顯示Component  
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentAudioToolPausedMode( {RecordedAnswerUrl, StateAnswerAudioStatus, PropsAssignReportStatus} )
    {   
        return(
            <>
                <div className={cssAssignmentComposition.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(RecordedAnswerUrl, StateAnswerAudioStatus)}/>
                <div className={cssAssignmentComposition.btnAudioStop} onClick={() => AudioStopOnTapHandler()}/>

                <ComponentAudioDeleteButton PropsAssignReportStatus={PropsAssignReportStatus}/>
            </>
        )
    } // end of ComponentAudioToolPausedMode

    /*===========================================
    summary: 音檔工具列 播放模式 顯示Component  
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentAudioToolPlayingMode( {PropsAssignReportStatus} )
    {   
        return(
            <>
                <div className={cssAssignmentComposition.btnAudioPause} onClick={() => AudioPauseOnTapHandler()}/>
                <div className={cssAssignmentComposition.btnAudioStop} onClick={() => AudioStopOnTapHandler()}/>

                <ComponentAudioDeleteButton PropsAssignReportStatus={PropsAssignReportStatus}/>
            </>
        )
    } // end of ComponentAudioToolPlayingMode

    /*===========================================
    summary: 音檔工具列 停止模式 顯示Component  
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentAudioToolStopMode( {RecordedAnswerUrl, StateAnswerAudioStatus, PropsAssignReportStatus} )
    {   
        return(
            <>
                <div className={cssAssignmentComposition.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(RecordedAnswerUrl, StateAnswerAudioStatus)}/>
                <div className={cssAssignmentComposition.btnAudioStopDisabled}/>

                <ComponentAudioDeleteButton PropsAssignReportStatus={PropsAssignReportStatus}/>
            </>
        )
    } // end of ComponentAudioToolStopMode
                
    /*===========================================
    summary: 音檔顯示時間 顯示Component  
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function ComponentAudioTime( {StateAnswerAudioCurrentTime, AnswerAudioDuration} )
    {   
        let strTime = GetDisplayTime(StateAnswerAudioCurrentTime) + " / " + GetDisplayTime(AnswerAudioDuration)
        return(
            <div className={cssAssignmentComposition.divAudioTime}>
                {strTime}
            </div>
        )
    } // end of ComponentAudioTime

    /*===========================================
    summary: 評語按鈕 顯示Component  
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function ComponentSwitch4CommentsButton( {StateSwitchType, PropsAssignReportStatus} )
    {   
        let strButton = window.gAppUI.LBL_TeachersComments

        if (PropsAssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            strButton = window.gAppUI.LBL_CompositionAddComments
        }

        return(
            <div className={GetSwitch4CommentsButtonCls(StateSwitchType)} onClick={() => CommentsOnTapHandler()}>
                {strButton}
            </div>
        )
    } // end of ComponentSwitch4CommentsButton                
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 評語 文字區域 看考卷 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderCommentTextResultAreaWrapper(DisplayQuestion, StateSubTextHeight)
    {
        let objStyle = GetTextAreaStyle(StateSubTextHeight)
        
        return (
            <div className={cssAssignmentComposition.divCommentTextArea} style={objStyle}>
                <div className={cssAssignmentComposition.divCommentTextEditIcon}/>

                <div ref={mrefCommentText} className={cssAssignmentComposition.divCommentText4Result}>
                    <div ref={mrefSubCommentText} className={cssAssignmentComposition.divSubCommentText4Result}>
                        {DisplayQuestion.TeacherFeedbackText}
                    </div>
                </div>

                {RenderTextMoreButtonWrapper(isShowTextMore, subTextHeight)}
            </div>
        )
    } // end of RenderCommentTextResultAreaWrapper

    /*===========================================
    summary: Render 評語 文字區域 改考卷 的顯示
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function RenderCommentTextScoreItAreaWrapper(DisplayQuestion, StateFeedbackText)
    {        
        return (
            <div className={cssAssignmentComposition.divCommentTextArea}>
                <div className={cssAssignmentComposition.divCommentTextEditIcon}/>

                <div className={cssAssignmentComposition.divCommentText4ScoreIt}>
                    <label htmlFor="textareaFeedback" className={cssAssignmentComposition.divHidden}>
                        {window.gAppUI.LBL_WritingCommentsPlaceHolder}
                    </label>
                    <textarea id="textareaFeedback"
                        className={cssAssignmentComposition.txtFeedback} 
                        value={StateFeedbackText}
                        placeholder={window.gAppUI.LBL_WritingCommentsPlaceHolder} 
                        maxLength={MAX_FEEDBACK_CHARACHERS}
                        onChange={(event) => FeedbackChangeHandler(event, StateFeedbackText)}
                    />
                </div>

                <div className={cssAssignmentComposition.btnPaste} onClick={() => PasteEventHandler(StateFeedbackText, DisplayQuestion.CompositionAns)}> 
                    {window.gAppUI.BTN_PasteStudentAnswer}
                </div>
            </div>
        )
    } // end of RenderCommentTextScoreItAreaWrapper

    /*===========================================
    summary: Render 評語 Video Tool 看考卷模式 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderCommentVideoToolResultWrapper(DisplayQuestion)
    {
        let objBlock = ""
        if (
            (typeof (DisplayQuestion.TeacherFeedbackVideoUrl) !== 'undefined') &&
            (DisplayQuestion.TeacherFeedbackVideoUrl !== null) &&
            (DisplayQuestion.TeacherFeedbackVideoUrl !== "")
            )
        {   
            objBlock = <div className={cssAssignmentComposition.btnVideoPlay} onClick={() => VideoPlayOnTapHandler(DisplayQuestion.TeacherFeedbackVideoUrl)}/>
        }
        else
        {
            // Comment No Video
            objBlock = <div className={cssAssignmentComposition.btnVideoPlayDisabled}/>
        }

        return (
            <div className={cssAssignmentComposition.divVideoTool}>
                {objBlock}
            </div>
        )
    } // end of RenderCommentVideoToolResultWrapper

    /*===========================================
    summary: Render 評語 Video Tool 改考卷模式 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderCommentVideoToolScoreItWrapper(DisplayQuestion)
    {
        let objBlock = ""
        if (
            (typeof (DisplayQuestion.TeacherFeedbackVideoUrl) !== 'undefined') &&
            (DisplayQuestion.TeacherFeedbackVideoUrl !== null) &&
            (DisplayQuestion.TeacherFeedbackVideoUrl !== "")
            )
        {   
            objBlock =  <div className={cssAssignmentComposition.divVideoTool}>
                            <div className={cssAssignmentComposition.divVideoDeleteSpacer} />
                            <div className={cssAssignmentComposition.btnVideoPlay} onClick={() => VideoPlayOnTapHandler(DisplayQuestion.TeacherFeedbackVideoUrl)}/>
                            <div className={cssAssignmentComposition.btnVideoDelete} onClick={() => VideoDeleteOnTapHandler()}/>
                        </div>
        }
        else
        {
            // Comment No Video
            if (!window.gSession.App.InApp)
            {
                objBlock =  <div className={cssAssignmentComposition.divVideoTool4ScoreIt}>
                                <div className={cssAssignmentComposition.divVideoRecordIcon}/>
                                <div className={cssAssignmentComposition.divVideoRecordMessage4App}>
                                    {window.gAppUI.LBL_AssessmentVideoMsg}
                                </div>
                            </div>
            }
            else
            {
                objBlock =  <div className={cssAssignmentComposition.btnVideoRecordMain} onClick={() => VideoRecordOnTapHandler()}>
                                <div className={cssAssignmentComposition.divVideoRecordMessage}>
                                    {window.gAppUI.LBL_TapToStartRecording}
                                </div>

                                <div className={cssAssignmentComposition.btnVideoRecord}/>
                            </div>
            }
        }

        return objBlock
    } // end of RenderCommentVideoToolScoreItWrapper

    /*===========================================
    summary: Render 評語 影片檔區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderCommentVideoAreaWrapper(DisplayQuestion, PropsAssignReportStatus)
    {
        let objVideoToolBlock = ""
        if (PropsAssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            objVideoToolBlock = RenderCommentVideoToolScoreItWrapper(DisplayQuestion)
        }
        else
        {
            objVideoToolBlock = RenderCommentVideoToolResultWrapper(DisplayQuestion)
        }

        return (
            <div className={cssAssignmentComposition.divCommentVideoArea}>
                {objVideoToolBlock}
                <div className={cssAssignmentComposition.divCommentVideoIcon}/>
            </div>
        )
    } // end of RenderCommentVideoAreaWrapper
    
    /*===========================================
    summary: Render Answer Audio Tool 看考卷模式 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderCommentAudioToolResultWrapper(DisplayQuestion, StateAnswerAudioStatus)
    {
        let objBlock = ""
        if (
            (typeof (DisplayQuestion.TeacherFeedbackAudioUrl) !== 'undefined') &&
            (DisplayQuestion.TeacherFeedbackAudioUrl !== null) &&
            (DisplayQuestion.TeacherFeedbackAudioUrl !== "")
            )
        {   
            if (StateAnswerAudioStatus === window.gAudioStatusEnum.Stop)
            {
                // window.gAudioStatusEnum.Stop
                objBlock = <ComponentAudioToolStopMode RecordedAnswerUrl={DisplayQuestion.TeacherFeedbackAudioUrl} 
                                StateAnswerAudioStatus={StateAnswerAudioStatus}
                                PropsAssignReportStatus={-1}/>
            }
            else if (StateAnswerAudioStatus === window.gAudioStatusEnum.Playing)
            {
                // window.gAudioStatusEnum.Playing
                objBlock = <ComponentAudioToolPlayingMode PropsAssignReportStatus={-1}/>
            }
            else
            {
                // window.gAudioStatusEnum.Paused
                objBlock = <ComponentAudioToolPausedMode RecordedAnswerUrl={DisplayQuestion.TeacherFeedbackAudioUrl} 
                                StateAnswerAudioStatus={StateAnswerAudioStatus}
                                PropsAssignReportStatus={-1}/>
            }
        }
        else
        {
            // Comment No Audio
            objBlock = <ComponentAudioToolNoAudioMode/>
        }

        return (
            <div className={cssAssignmentComposition.divSubAudioArea}>
                <div className={cssAssignmentComposition.divAudioTool}>
                    {objBlock}
                </div>

                <ComponentAudioTime StateAnswerAudioCurrentTime={answerAudioCurrentTime} AnswerAudioDuration={mintAnswerAudioDuration} />
            </div>
        )
    } // end of RenderCommentAudioToolResultWrapper

    /*===========================================
    summary: Render Answer Audio Tool 改考卷模式 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderCommentAudioToolScoreItWrapper(DisplayQuestion, StateAnswerAudioStatus, PropsAssignReportStatus)
    {
        let objSubAudioArea = ""
        let objBlock = ""
        if (
            (typeof (DisplayQuestion.TeacherFeedbackAudioUrl) !== 'undefined') &&
            (DisplayQuestion.TeacherFeedbackAudioUrl !== null) &&
            (DisplayQuestion.TeacherFeedbackAudioUrl !== "")
            )
        {   
            if (StateAnswerAudioStatus === window.gAudioStatusEnum.Stop)
            {
                // window.gAudioStatusEnum.Stop
                objBlock = <ComponentAudioToolStopMode RecordedAnswerUrl={DisplayQuestion.TeacherFeedbackAudioUrl} 
                                StateAnswerAudioStatus={StateAnswerAudioStatus}
                                PropsAssignReportStatus={PropsAssignReportStatus}/>
            }
            else if (StateAnswerAudioStatus === window.gAudioStatusEnum.Playing)
            {
                // window.gAudioStatusEnum.Playing
                objBlock = <ComponentAudioToolPlayingMode PropsAssignReportStatus={PropsAssignReportStatus}/>
            }
            else
            {
                // window.gAudioStatusEnum.Paused
                objBlock = <ComponentAudioToolPausedMode RecordedAnswerUrl={DisplayQuestion.TeacherFeedbackAudioUrl} 
                                StateAnswerAudioStatus={StateAnswerAudioStatus}
                                PropsAssignReportStatus={PropsAssignReportStatus}/>
            }

            objSubAudioArea =   <div className={cssAssignmentComposition.divSubAudioArea}>
                                    <div className={cssAssignmentComposition.divAudioTool}>
                                        {objBlock}
                                    </div>

                                    <ComponentAudioTime StateAnswerAudioCurrentTime={answerAudioCurrentTime} 
                                        AnswerAudioDuration={mintAnswerAudioDuration} />
                                </div>
        }
        else
        {
            // Comment No Audio
            objSubAudioArea =   <div className={cssAssignmentComposition.btnAudioRecordMain} onClick={() => AudioRecordOnTapHandler()}>
                                    <div className={cssAssignmentComposition.divAudioRecordMessage}>
                                        {window.gAppUI.LBL_TapToStartRecording}
                                    </div>

                                    <div className={cssAssignmentComposition.btnAudioRecord}/>
                                </div>
                                
        }

        return objSubAudioArea
    } // end of RenderCommentAudioToolScoreItWrapper

    /*===========================================
    summary: Render 評語 音檔區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderCommentAudioAreaWrapper(DisplayQuestion, PropsAssignReportStatus)
    {
        let objBlock = ""
        if (PropsAssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            objBlock = RenderCommentAudioToolScoreItWrapper(DisplayQuestion, answerAudioStatus, PropsAssignReportStatus)
        }
        else
        {
            objBlock = RenderCommentAudioToolResultWrapper(DisplayQuestion, answerAudioStatus)
        }

        return (
            <div className={cssAssignmentComposition.divCommentAudioArea}>
                {objBlock}

                <div className={cssAssignmentComposition.divCommentAudioIcon}/>
            </div>
        )
    } // end of RenderCommentAudioAreaWrapper

    /*===========================================
    summary: Render SubAnswer 4 評語 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderSubAnswer4CommentsWrapper(DisplayQuestion, PropsAssignReportStatus)
    {
        if (PropsAssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            return (
                <>
                    {RenderCommentAudioAreaWrapper(DisplayQuestion, PropsAssignReportStatus)}
                    {RenderCommentVideoAreaWrapper(DisplayQuestion, PropsAssignReportStatus)}
                    {RenderCommentTextScoreItAreaWrapper(DisplayQuestion, feedbackText)}
                </>
            )
        }
        else
        {
            return (
                <>
                    {RenderCommentAudioAreaWrapper(DisplayQuestion, PropsAssignReportStatus)}
                    {RenderCommentVideoAreaWrapper(DisplayQuestion, PropsAssignReportStatus)}
                    {RenderCommentTextResultAreaWrapper(DisplayQuestion, subTextHeight)}
                </>
            )
        }
    } // end of RenderSubAnswer4CommentsWrapper

    /*===========================================
    summary: Render 更多按鈕 ˋ Student Answer 文字區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderAnswerImageAreaWrapper(DisplayQuestion)
    {
        return (
            <div className={cssAssignmentComposition.divAnswerImageArea}>
                <ComponentImageUnit ImageAnswerUrl={DisplayQuestion.ImageAnswer01Url} />
                <ComponentImageUnit ImageAnswerUrl={DisplayQuestion.ImageAnswer02Url} />
                <ComponentImageUnit ImageAnswerUrl={DisplayQuestion.ImageAnswer03Url} />
            </div>
        )
    } // end of RenderAnswerImageAreaWrapper

    /*===========================================
    summary: Render 更多按鈕 ˋ Student Answer 文字區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderTextMoreButtonWrapper(StateIsShowTextMore, StateSubTextHeight)
    {
        if (
            (StateIsShowTextMore) &&
            (StateSubTextHeight < 0)
            )
        {
            return (
                <div className={cssAssignmentComposition.btnMore4TextAnswer} onClick={() => MoreEventHandler()}>
                    {window.gAppUI.BTN_More}
                </div>
            )
        }
    } // end of RenderTextMoreButtonWrapper
    
    /*===========================================
    summary: Render Student Answer 文字區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderAnswerTextAreaWrapper(DisplayQuestion, StateSubTextHeight)
    {
        let objStyle = GetTextAreaStyle(StateSubTextHeight)

        return (
            <div className={cssAssignmentComposition.divAnswerTextArea} style={objStyle}>
                <div className={cssAssignmentComposition.divAnswerTextEditIcon}/>

                <div ref={mrefAnswerText} className={cssAssignmentComposition.divAnswerText}>
                    <div ref={mrefSubAnswerText} className={cssAssignmentComposition.divSubAnswerText}>
                        {DisplayQuestion.CompositionAns}
                    </div>
                </div>

                {RenderTextMoreButtonWrapper(isShowTextMore, StateSubTextHeight)}
            </div>
        )
    } // end of RenderAnswerTextAreaWrapper

    /*===========================================
    summary: Render Answer Audio Tool 沒檔案 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderAnswerAudioToolNoAudioWrapper()
    {
        return (
            <div className={cssAssignmentComposition.divSubAudioArea}>
                <div className={cssAssignmentComposition.divAudioRecordMessageDisabled}>
                    {window.gAppUI.LBL_TapToStartRecording}
                </div>

                <div className={cssAssignmentComposition.divAudioRecordIcon}/>
            </div>
        )
    } // end of RenderAnswerAudioToolNoAudioWrapper

    /*===========================================
    summary: Render Answer Audio Tool 有檔案 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderAnswerAudioToolHaveAudioWrapper(DisplayQuestion, StateAnswerAudioStatus)
    {
        let objBlock = ""
        if (StateAnswerAudioStatus === window.gAudioStatusEnum.Stop)
        {
            // window.gAudioStatusEnum.Stop
            objBlock = <ComponentAudioToolStopMode RecordedAnswerUrl={DisplayQuestion.RecordedAnswerUrl} 
                            StateAnswerAudioStatus={StateAnswerAudioStatus}
                            PropsAssignReportStatus={-1}/>
        }
        else if (StateAnswerAudioStatus === window.gAudioStatusEnum.Playing)
        {
            // window.gAudioStatusEnum.Playing
            objBlock = <ComponentAudioToolPlayingMode PropsAssignReportStatus={-1}/>
        }
        else
        {
            // window.gAudioStatusEnum.Paused
            objBlock = <ComponentAudioToolPausedMode RecordedAnswerUrl={DisplayQuestion.RecordedAnswerUrl} 
                            StateAnswerAudioStatus={StateAnswerAudioStatus}
                            PropsAssignReportStatus={-1}/>
        }

        return (
            <div className={cssAssignmentComposition.divSubAudioArea}>
                <div className={cssAssignmentComposition.divAudioTool}>
                    {objBlock}
                </div>

                <ComponentAudioTime StateAnswerAudioCurrentTime={answerAudioCurrentTime} 
                    AnswerAudioDuration={mintAnswerAudioDuration} />
            </div>
        )
    } // end of RenderAnswerAudioToolHaveAudioWrapper

    /*===========================================
    summary: Render Answer Audio Tool 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderAnswerAudioToolWrapper(DisplayQuestion)
    {
        if (
            (typeof (DisplayQuestion.RecordedAnswerUrl) !== 'undefined') &&
            (DisplayQuestion.RecordedAnswerUrl !== null) &&
            (DisplayQuestion.RecordedAnswerUrl !== "")
            )
        {
            return RenderAnswerAudioToolHaveAudioWrapper(DisplayQuestion, answerAudioStatus)
        }
        else
        {
            return RenderAnswerAudioToolNoAudioWrapper()
        }
    } // end of RenderAnswerAudioToolWrapper

    /*===========================================
    summary: Render Student Answer 音檔區域 的顯示
    remarks: 000 Tim 2021/12/10 Create
    ===========================================*/
    function RenderAnswerAudioAreaWrapper(DisplayQuestion)
    {
        return (
            <div className={cssAssignmentComposition.divAnswerAudioArea}>
                {RenderAnswerAudioToolWrapper(DisplayQuestion)}
            </div>
        )
    } // end of RenderAnswerAudioAreaWrapper
    
    /*===========================================
    summary: Render SubAnswer 4 學生答案 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderSubAnswer4StudentAnswerWrapper(DisplayQuestion)
    {
        return (
            <>
                {RenderAnswerAudioAreaWrapper(DisplayQuestion)}
                {RenderAnswerTextAreaWrapper(DisplayQuestion, subTextHeight)}
                {RenderAnswerImageAreaWrapper(DisplayQuestion)}
            </>
        )
    } // end of RenderSubAnswer4StudentAnswerWrapper
    
    /*===========================================
    summary: Render Sub Answer Unit 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderSubAnswerWrapper(StateSwitchType)
    {
        let objBlock = null
        if (StateSwitchType === SwitchTypeEnum.StudentAnswer)
        {
            objBlock = RenderSubAnswer4StudentAnswerWrapper(mobjDisplayQuestion)
        }
        else
        {
            objBlock = RenderSubAnswer4CommentsWrapper(mobjDisplayQuestion, props.AssignReportStatus)
        }

        return (
            <div className={cssAssignmentComposition.divSubAnswerMain}>
                {objBlock}
            </div>
        )
    } // end of RenderSubAnswerWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderSwitchToolWrapper(StateSwitchType)
    {
        return (
            <div className={cssAssignmentComposition.divSwitchToolArea}>
                <div className={GetSwitch4StudentAnswerButtonCls(StateSwitchType)} onClick={() => StudentAnswerOnTapHandler()}>
                    {window.gAppUI.LBL_StudentsAnswer}
                </div>

                <ComponentSwitch4CommentsButton StateSwitchType={StateSwitchType} PropsAssignReportStatus={props.AssignReportStatus}/>
            </div>
        )
    } // end of RenderSwitchToolWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderAnswerWrapper()
    {
        return (
            <div className={cssAssignmentComposition.divAnswerMain}>
                {RenderSwitchToolWrapper(switchType)}

                {RenderSubAnswerWrapper(switchType)}
            </div>
        )
    } // end of RenderAnswerWrapper

    /*===========================================
    summary: Render Content Text 的顯示
    remarks: 000 Tim 2021/12/09 Create
             001 Tim 2022/01/21 加入 滾動條 Top More提示按鈕
             002 Tim 2022/08/25 調整 先顯示 作答區，題目區 等 縮圖 讀好 再顯示
    ===========================================*/
    function RenderContentTextWrapper(StateUpdateDataTime, ContentText)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentComposition.divContentTextMain}>
                    <div  ref={mrefScrollArea} className={cssAssignmentComposition.divContentText}
                            onScroll={(event) => ScrollAreaScrollEventHandler(event)}>
                        {parse(ContentText)}
                    </div>
                    <div className={GetScrollDisplayCls(scrollDisplayType)} onClick={() => ScrollDisplayOnTapHandler()}/>
                </div>
            )
        }
        else
        {
            return (
                <div className={cssAssignmentComposition.divContentTextMain}>
                    <div className={cssAssignmentComposition.divCircularProgressArea}>
                        {/* Change color and position of CircularProgress? Ref: https://stackoverflow.com/questions/59709633/change-color-and-position-of-circularprogress */}
                        <CircularProgress />
                    </div>
                </div>
            )
        }        
    } // end of RenderContentTextWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/09 Create
             001 Tim 2022/08/25 調整 先顯示 作答區，題目區 等 縮圖 讀好 再顯示
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderContentTextWrapper(updateDataTime, mobjDisplayQuestion.ContentText)}
                {RenderAnswerWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentComposition.divMain}>
                {RenderContentWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentComposition